import * as GQL from '~/graphql/generated/client';

export const useUserControlTasksPaginated = (input: {
  page: number;
  pageSize: number;
  search?: string;
  projectType?: GQL.ProjectType;
  status?: GQL.ControlAssignmentStatus;
  filter: GQL.TaskFilter;
}) => {
  const { data, loading, error, refetch } =
    GQL.useUserControlTasksPaginatedQuery({
      variables: {
        input: {
          pagination: {
            page: input.page,
            pageSize: input.pageSize,
          },
          search: input.search,
          projectType: input.projectType,
          status: input.status,
          filter: input.filter,
        },
      },
      fetchPolicy: 'cache-and-network',
    });

  return {
    tasks: data?.userControlTasksPaginated.tasks ?? [],
    totalCount: data?.userControlTasksPaginated.totalCount ?? 0,
    hasNextPage: data?.userControlTasksPaginated.hasNextPage ?? false,
    hasPreviousPage: data?.userControlTasksPaginated.hasPreviousPage ?? false,
    loading,
    error,
    refetch,
  };
};
